import api from './api';

export interface MovMoneda {
    [key: string]: any;
}

const tryParseNumber = (value: any): number => {
    const n = Number(value);
    return Number.isFinite(n) ? n : NaN;
};

const getDateMillis = (item: any): number => {
    if (!item || typeof item !== 'object') return 0;
    // Intentar múltiples posibles nombres de campo de fecha
    const candidates = [
        item.fecha,
        item.fechaMovimiento,
        item.fechaCotizacion,
        item.fechaOperacion,
        item.fechaAlta,
        item.createdAt,
        item.updatedAt
    ];
    for (const c of candidates) {
        if (c) {
            const d = new Date(c);
            const t = d.getTime();
            if (Number.isFinite(t)) return t;
        }
    }
    return 0;
};

const getCotizacionValue = (item: any): number => {
    if (!item || typeof item !== 'object') return NaN;
    // Intentar múltiples posibles nombres de campo de cotización
    const candidates = [
        item.cotizacion,
        item.valor,
        item.valorCotizacion,
        item.tipoCambio,
        item.tc,
        item.precio,
        item.importe
    ];
    for (const c of candidates) {
        const n = tryParseNumber(c);
        if (Number.isFinite(n) && n > 0) return n;
    }
    return NaN;
};

const movMonedaService = {
    // Obtiene la última cotización (por fecha más reciente) desde GET /api/MovMoneda
    getUltimaCotizacion: async (): Promise<number | null> => {
        const resp = await api.get('/api/MovMoneda');
        const raw = resp?.data;
        const items: any[] = Array.isArray(raw?.items)
            ? raw.items
            : Array.isArray(raw)
                ? raw
                : [];
        if (!Array.isArray(items) || items.length === 0) return null;

        // Ordenar por fecha descendente y tomar la primera con cotización válida
        const sorted = [...items].sort((a, b) => getDateMillis(b) - getDateMillis(a));
        for (const it of sorted) {
            const v = getCotizacionValue(it);
            if (Number.isFinite(v) && v > 0) {
                return v;
            }
        }
        return null;
    },
    
    // Obtiene la cotización por codigoMoneda y fecha actual desde GET /api/MovMoneda/{codigoMoneda}/{fechaCotizacion}
    getUltimaCotizacionPorMoneda: async (codigoMoneda: number): Promise<number | null> => {
        if (!codigoMoneda || codigoMoneda <= 0) {
            return null;
        }
        
        try {
            // Obtener la fecha actual en formato ISO
            const fechaCotizacion = new Date().toISOString();
            
            // Construir la URL con el codigoMoneda y fechaCotizacion como parámetros de ruta
            const url = `/api/MovMoneda/${codigoMoneda}/${encodeURIComponent(fechaCotizacion)}`;
            const resp = await api.get(url);
            const raw = resp?.data;
            
            // El endpoint puede devolver directamente la cotización o un objeto
            if (typeof raw === 'number' && Number.isFinite(raw) && raw > 0) {
                return raw;
            }
            
            // Si devuelve un objeto, intentar obtener el valor de cotización
            if (raw && typeof raw === 'object') {
                const v = getCotizacionValue(raw);
                if (Number.isFinite(v) && v > 0) {
                    return v;
                }
            }
            
            return null;
        } catch (error) {
            console.error(`Error al obtener cotización para códigoMoneda ${codigoMoneda}:`, error);
            return null;
        }
    }
};

export default movMonedaService;



